exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__TechnicalMessageDot__root,\n.DS__TechnicalMessageDot__active {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n  .DS__TechnicalMessageDot__root {\n  display: block;\n  width: 6px;\n  height: 6px;\n  background: #ffffff;\n  border-radius: 4px;\n  box-shadow: 0px 0px 4px rgba(34, 42, 55, 0.04);\n  transition: width 0.3s linear;\n}\n\n  @media screen and (prefers-reduced-motion: reduce) {.DS__TechnicalMessageDot__root {\n    transition: none\n}\n  }\n\n.DS__TechnicalMessageDot__active {\n  width: 40px;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__TechnicalMessageDot__root",
	"active": "DS__TechnicalMessageDot__active"
};